import { dbs } from "../firebase/firestore"
import { functions } from '../firebase/firebase'
import { fieryActions, fieryBindings, fieryMapMutations, fieryState, FieryRecordSave, FieryRecordRemove } from 'fiery-vuex'
import { User, UserOptions } from "./shared/user"

const usersDB: any = dbs.users

export default {
	namespaced: true,
	state: {
		current: null,
		loggedIn: false,
		fbu_init: false,
		user: {
			fist_name: '',
			last_name: ''
		},
		settings: null,
		super: false,
		id_token: null,
		claims: null,
        perms: {},
        providers: [],
		metadata: null,
		FBC: {},
		stripe_customer: {},
		just_registered: false,
		auth_cb_init: false
	},
	mutations: {
		SET_AUTH_CB_INIT( state, init ){
			state.auth_cb_init = init
		},
		SET_JUST_REGISTERED( state, new_user ){
			state.just_registered = new_user
		},
		SET_USER_PROVIDERS(state, providers) {
			state.providers = providers
		},
		SET_CURRENT_CLAIMS(state, claims) {
			state.claims = claims || {}
		},
		LOGOUT_USER( state, payload ){
			state.current = null
			state.user = null
			state.claims = null
		},
		SET_LOGGED_IN( state, loggedIn ){
			state.loggedIn = loggedIn
		},
		SET_CURRENT_USER(state, payload) {
			state.current = payload || {}
		},
		UPDATE_USER_PROFILE(state, settings) {
			console.log( " !!!! UPDATE_USER_PROFILE !!!!", Object.assign({}, state.settings) )
			settings = settings || state.settings
			settings.updatedAt = new Date()
			settings.save()
		},
		SET_USER( state, getData ){
            const refresh_stripe = state.user && state.user.refresh_stripe ? state.user.refresh_stripe : false
            const refresh_token = state.user && state.user.refresh_token ? state.user.refresh_token : false
            const updated_data = getData()

            if( updated_data ){

				if ( refresh_token && updated_data.refresh_token && state.current && updated_data.refresh_token > refresh_token ){
					console.log("REFRESHING FB USER ID TOKEN!")
					state.id_token = state.current.getIdToken(true)
				}
				
				if ( updated_data.refresh_stripe && updated_data.refresh_stripe > refresh_stripe ){
					console.log("REFRESHING STRIPE DATA", this )
					// @ts-ignore
					this.dispatch("stripe/refreshStripeData", updated_data.id, { root: true })
				}

            }

            state.user = updated_data
        },
		SET_ID_TOKEN( state, token ){
			state.id_token = token
		},
	},
	getters: {
		superAdmin(state, getters, rootState, rootGetters) {
			return state.claims && state.claims.role && state.claims.role === "super"
		},
		admin(state, getters, rootState, rootGetters) {
			return ( state.user && state.user.role && ( state.user.role === "admin" || state.user.role === "super") )
		},
		agent(state, getters, rootState, rootGetters) {
			return ! getters.superAdmin && ! getters.admin
		},
		uid(state, getters, rootState, rootGetters) {
			return state.current && state.current.uid ? state.current.uid : ""
		},
	},
	actions: {
		...fieryBindings( {
				fetchUser({ state, dispatch, commit }, userID, $fiery): User {
                    userID = userID || state.current.uid
                    const doc = usersDB.doc(userID)
                    console.log( 'fetchUser doc', doc )
					return $fiery(doc, UserOptions, "SET_USER" )
                },
			},
			{ commitInitial: false }
		),
		async updateUserEmailAddress( {state, dispatch, commit }, newEmail ){
			return usersDB.doc( state.current.uid ).update({
				email: newEmail
			})
		},
		async setUserPermissions({ state, dispatch, commit }, payload ) {
				let role = state.claims && state.claims.role ? state.claims.role : "agent"
				await dispatch("roles/fetchUserRole", role, {
					root: true
				})

			return true
		},
		async stateChanged({ state, dispatch, commit, rootState }, user) {
			console.log("stateChanged", Object.assign({}, user) )
			commit( 'SET_AUTH_CB_INIT', true )
			if (user) {
				await commit('SET_LOGGED_IN', true )
				await commit("SET_CURRENT_USER", user)

				if (user.providerData) {
					let providers = user.providerData.map(pd => pd.providerId)
					console.log("FOUND PROVIDERS", providers)
					await commit("SET_USER_PROVIDERS", providers)
				}

				try {
					let tokenResult = await user.getIdTokenResult()
					// console.log( 'tokenResult', tokenResult, tokenResult.token )
					await commit("SET_ID_TOKEN", tokenResult.token)
					await commit( "SET_CURRENT_CLAIMS", tokenResult.claims )
				} catch (e) {
					console.log("Token Result Error!", e)
				}
				
				if( ! state.settings ){
					// await dispatch("fetchUserSettings")
				}
				
				console.log( '!!!!! USER STATE CHANGED FETCHING USER AND STRIPE CUSTOMER !!!!', state.user, state.current )

				await dispatch("fetchUser")
			
				if( ! state.user.email ){
					// await dispatch("fetchUser")
					// dispatch('stripe/fetchStripeCustomer', user.uid, { root: true })
				}

				if( ! state.metadata ){
					// await dispatch("fetchUserMetaData")
				}

                // if( ! rootState.roles.currentUser ) {
				// 	await dispatch("setUserPermissions")
				// }

				// await dispatch('roles/fetchRoles', false, { root: true })

				// Check if firebase user email address is different from stored email on user account
				if( state.user && state.user.email && state.current && state.current.email && state.user.email !== state.current.email ){

					console.log( '!!!!! FIREBASE USER EMAIL DOES NOT MATCH USER DB EMAIL ADDRESS !!!!', state.user.email, state.current.email )
					/**
					 * Make sure to update user profile db with firebase related email address
					 * 
					 * This should only be necessary to handle if the user clicks the link in the email to "revert" back their email
					 * address after changing it.  Otherwise the emails should technically always match.
					 */
					await dispatch( 'updateUserEmailAddress', state.current.email )
				}
			} else {
				await commit('SET_LOGGED_IN', false)
				// Set all values as no user (reset if necessary)
				await commit("SET_CURRENT_USER")
				// await commit("SET_USER_SETTINGS")
			}

			return true
		}
	}
}